import { getPath } from '@/router/common'

const baseUrl = {
  title: '车源信息',
  path: 'CYInfo'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'CYInfo_index',
    component: () =>
      import(
        /* webpackChunkName: "CYInfo_index" */ '@/views/cYInfo/index/index.vue'
      ),
    meta: {
      title: '车源信息'
    }
  },
  {
    path: getPath('TakePhone', baseUrl),
    name: 'CYInfo_TakePhone',
    component: () => import(/* webpackChunkName: "CYInfo_TakePhone" */ '@/views/cYInfo/takePhone/index.vue'),
    meta: {
      title: '拨打电话'
    }
  },
  {
    path: getPath('MapShow', baseUrl),
    name: 'CYInfo_MapShow',
    component: () => import(/* webpackChunkName: "CYInfo_MapShow" */ '@/views/cYInfo/mapShow/index.vue'),
    meta: {
      title: '地图显示'
    }
  }
]
